import { publicConfig } from './public-config';
const packageJson = require('../../../../package.json');

export const environment = {
  appName: 'Kailo',
  envName: 'STAGE',
  production: true,
  test: false,
  i18nPrefix: '',
  apiBaseUrl: 'https://api.kailo.dk',
  googleAnalyticsCode: publicConfig.googleAnalyticsCode,
  googleClientId: publicConfig.googleClientId,
  googleMapsApiKey: publicConfig.googleMapsApiKey,
  versions: {
    app: packageJson.version,
    angular: packageJson.dependencies['@angular/core'],
    ngrx: packageJson.dependencies['@ngrx/store'],
    material: packageJson.dependencies['@angular/material'],
    bootstrap: packageJson.dependencies.bootstrap,
    rxjs: packageJson.dependencies.rxjs,
    ngxtranslate: packageJson.dependencies['@ngx-translate/core'],
    fontAwesome: packageJson.dependencies['@fortawesome/fontawesome-free'],
    angularCli: packageJson.devDependencies['@angular/cli'],
    typescript: packageJson.devDependencies['typescript'],
    cypress: packageJson.devDependencies['cypress']
  }
};
